import { render, staticRenderFns } from "./shopRetailRecord.vue?vue&type=template&id=016e8ef2&scoped=true&"
import script from "./shopRetailRecord.vue?vue&type=script&lang=js&"
export * from "./shopRetailRecord.vue?vue&type=script&lang=js&"
import style0 from "./shopRetailRecord.vue?vue&type=style&index=0&id=016e8ef2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016e8ef2",
  null
  
)

export default component.exports